if (!customElements.get('secondary-load-button')) {
  customElements.define(
    'secondary-load-button',
    class SecondaryLoadButton extends HTMLButtonElement {
      constructor() {
        super();
        this.onClickHandler = this.onClick.bind(this);
        this.appendedCount = 0;
        this.currentPage = 1;
        this.loading = false;
      }

      connectedCallback() {
        this.addEventListener('click', this.onClickHandler);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClickHandler);
      }

      async onClick() {
        if (this.loading) return;
        this.loading = true;
        this.classList.add('pointer-events-none');
        this.classList.add('btn--loading');

        try {
          const productsToAppendThisClick = 40;
          const pageSize = parseInt(this.dataset.pageSize || '20', 10);
          const sectionId = this.dataset.sectionId;
          const baseUrl = this.dataset.baseUrl; // e.g., https://domain/collections/handle

          let appendedThisClick = 0;
          // Continue fetching pages until we reach ~40 items appended or no products
          while (appendedThisClick < productsToAppendThisClick) {
            const pageUrl = new URL(baseUrl);
            pageUrl.searchParams.set('page', String(this.currentPage));
            if (sectionId) pageUrl.searchParams.set('section_id', sectionId);

            const responseText = await fetch(pageUrl.toString()).then((r) => r.text());
            const appended = this.appendProductsFromResponse(responseText);
            if (appended === 0) break; // No more products

            appendedThisClick += appended;
            this.appendedCount += appended;
            this.currentPage += 1;

            // Safety: if the theme page size changes, avoid infinite loops
            if (appended < 1 || appended < pageSize) break;
          }

          // If no products appended at all, hide the button
          if (this.appendedCount === 0) {
            this.remove();
            return;
          }

          // If we likely reached the end (appended less than a full page), remove button
          if (this.lastAppendedLessThanPage || this.reachedTotalLimit()) {
            this.remove();
          }
        } catch (e) {
          console.error('Secondary load failed', e);
          // Fail silently for shoppers; re-enable button
        } finally {
          this.loading = false;
          this.classList.remove('pointer-events-none');
          this.classList.remove('btn--loading');
        }
      }

      appendProductsFromResponse(responseText) {
        const productGridContainer = document.getElementById('ProductGridContainer');
        if (productGridContainer === null) return 0;

        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const destinationList = productGridContainer.querySelector('.products-list');
        const sourceList = parsedHTML.querySelector('.products-list');
        if (!destinationList || !sourceList) return 0;

        const items = Array.from(sourceList.querySelectorAll('.f-column'));
        items.forEach((item) => destinationList.appendChild(item));

        // Let other scripts re-bind to newly appended cards
        document.dispatchEvent(new CustomEvent('collection:rerendered'));

        // Track if we likely reached the last page
        this.lastAppendedLessThanPage = items.length === 0 || items.length < (parseInt(this.dataset.pageSize || '20', 10));
        return items.length;
      }

      reachedTotalLimit() {
        const total = parseInt(this.dataset.total || '0', 10);
        if (!total) return false;
        const pageSize = parseInt(this.dataset.pageSize || '20', 10);
        // If we've fetched pages to cover total products, stop
        return this.currentPage * pageSize > total;
      }
    },
    { extends: 'button' }
  );
}


